import axios from "../../api/axios";
import { LegalEntityWithRepresentativeType } from "../../static/types/commonTypes/legalEntityType";
import { isValidRcs } from "./validateRCSNumber";

export const fetchCompanyDetailsByRcs = async (rcs: string): Promise<Partial<LegalEntityWithRepresentativeType> | null> => {

    // Vérification de la validité du RCS
    if ( !isValidRcs(rcs) ) {
        return null;
    }

    try {
        // Simuler un appel API
        const response = await axios(`rne/${rcs}`)

        const data = response.data.data as Partial<LegalEntityWithRepresentativeType>

        return { 
            companyName: data.companyName,
            legalForm: data.legalForm,
            capital: data.capital || 0,
            postalCode: data.postalCode,
            city: data.cities?.[0],
            cities: data.cities,
            address: data.address,
            registrationOffice: data.registrationOffice,
            additionalAddress: data.additionalAddress,
            rcs: data.rcs,
            firstName: data.firstName,
            lastName: data.lastName,
            civility: data.civility
        }
    } catch (error) {
        console.error("Erreur lors de la récupération des détails de l'entreprise", error);
        return null;
    }
};